// import Swal from "sweetalert2";

// // Theme colors matching the website
// const THEME_COLORS = {
//   primary: "#3969E7",
//   primaryDark: "#2a52cf",
//   danger: "#dc3545",
//   warning: "#ffc107",
//   success: "#28a745",
//   info: "#17a2b8",
//   text: "#212529",
//   border: "#ced4da",
//   background: "#ffffff",
// };

// // Common Swal configuration matching the theme
// const getBaseConfig = () => ({
//   customClass: {
//     popup: "swal-popup-theme",
//     title: "swal-title-theme",
//     htmlContainer: "swal-html-container-theme",
//     confirmButton: "swal-confirm-button-theme",
//     cancelButton: "swal-cancel-button-theme",
//     actions: "swal-actions-theme",
//   },
//   buttonsStyling: false,
//   allowOutsideClick: false,
//   allowEscapeKey: true,
// });

// // Inject theme styles
// const injectThemeStyles = () => {
//   if (document.getElementById("swal-theme-styles")) return;

//   const style = document.createElement("style");
//   style.id = "swal-theme-styles";
//   style.textContent = `
//     .swal-popup-theme {
//       font-family: 'Poppins', sans-serif !important;
//       font-size: 13px !important;
//       border-radius: 8px !important;
//       padding: 0 !important;
//     }
    
//     .swal-title-theme {
//       font-family: 'Poppins', sans-serif !important;
//       font-size: 20px !important;
//       font-weight: 600 !important;
//       color: ${THEME_COLORS.text} !important;
//       margin-bottom: 16px !important;
//     }
    
//     .swal-html-container-theme {
//       font-family: 'Poppins', sans-serif !important;
//       font-size: 13px !important;
//       color: ${THEME_COLORS.text} !important;
//       line-height: 1.5 !important;
//     }
    
//     .swal-confirm-button-theme {
//       font-family: 'Poppins', sans-serif !important;
//       font-size: 13px !important;
//       font-weight: 500 !important;
//       background-color: ${THEME_COLORS.primary} !important;
//       color: #ffffff !important;
//       border: none !important;
//       border-radius: 4px !important;
//       padding: 8px 20px !important;
//       margin: 0 4px !important;
//       cursor: pointer !important;
//       transition: background-color 0.2s ease !important;
//     }
    
//     .swal-confirm-button-theme:hover {
//       background-color: ${THEME_COLORS.primaryDark} !important;
//     }
    
//     .swal-confirm-button-theme:focus {
//       outline: none !important;
//       box-shadow: 0 0 0 0.2rem rgba(57, 105, 231, 0.25) !important;
//     }
    
//     .swal-cancel-button-theme {
//       font-family: 'Poppins', sans-serif !important;
//       font-size: 13px !important;
//       font-weight: 500 !important;
//       background-color: #ffffff !important;
//       color: ${THEME_COLORS.text} !important;
//       border: 1px solid ${THEME_COLORS.border} !important;
//       border-radius: 4px !important;
//       padding: 8px 20px !important;
//       margin: 0 4px !important;
//       cursor: pointer !important;
//       transition: all 0.2s ease !important;
//     }
    
//     .swal-cancel-button-theme:hover {
//       background-color: #f8f9fa !important;
//       border-color: #adb5bd !important;
//     }
    
//     .swal-cancel-button-theme:focus {
//       outline: none !important;
//       box-shadow: 0 0 0 0.2rem rgba(206, 212, 218, 0.5) !important;
//     }
    
//     .swal-actions-theme {
//       margin-top: 20px !important;
//       margin-bottom: 10px !important;
//       gap: 8px !important;
//       padding-bottom: 10px !important;
//     }
    
//     .swal2-icon {
//       font-family: 'Poppins', sans-serif !important;
//     }
    
//     .swal2-icon.swal2-error {
//       border-color: ${THEME_COLORS.danger} !important;
//       color: ${THEME_COLORS.danger} !important;
//     }
    
//     .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
//       background-color: ${THEME_COLORS.danger} !important;
//     }
    
//     .swal2-icon.swal2-warning {
//       border-color: ${THEME_COLORS.warning} !important;
//       color: ${THEME_COLORS.warning} !important;
//     }
    
//     .swal2-icon.swal2-success {
//       border-color: ${THEME_COLORS.success} !important;
//       color: ${THEME_COLORS.success} !important;
//     }
    
//     .swal2-icon.swal2-info {
//       border-color: ${THEME_COLORS.info} !important;
//       color: ${THEME_COLORS.info} !important;
//     }
//   `;
//   document.head.appendChild(style);
// };

// // Initialize styles on first import
// injectThemeStyles();

// /**
//  * Show error alert
//  * @param text - Error message text
//  * @param title - Error title (default: "Error")
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showError("Please add at least one item");
//  * showError("Invalid input", "Validation Failed");
//  */
// export const showError = (
//   text: string,
//   title: string = "Error"
// ): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "error",
//     title,
//     text,
//     confirmButtonText: "OK",
//   });
// };

// /**
//  * Show success alert
//  * @param text - Success message text
//  * @param title - Success title (default: "Success")
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showSuccess("GRN created successfully");
//  */
// export const showSuccess = (
//   text: string,
//   title: string = "Success"
// ): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "success",
//     title,
//     text,
//     confirmButtonText: "OK",
//   });
// };

// /**
//  * Show warning alert
//  * @param text - Warning message text
//  * @param title - Warning title (default: "Warning")
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showWarning("This action cannot be undone");
//  */
// export const showWarning = (
//   text: string,
//   title: string = "Warning"
// ): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "warning",
//     title,
//     text,
//     confirmButtonText: "OK",
//   });
// };

// /**
//  * Show info alert
//  * @param text - Info message text
//  * @param title - Info title (default: "Information")
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showInfo("Your changes have been saved");
//  */
// export const showInfo = (
//   text: string,
//   title: string = "Information"
// ): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "info",
//     title,
//     text,
//     confirmButtonText: "OK",
//   });
// };

// /**
//  * Show confirmation dialog
//  * @param text - Confirmation message text
//  * @param title - Confirmation title (default: "Are you sure?")
//  * @param confirmButtonText - Confirm button text (default: "Yes")
//  * @param cancelButtonText - Cancel button text (default: "No")
//  * @returns Promise that resolves with result.isConfirmed = true if confirmed
//  * 
//  * @example
//  * showConfirm("Any unsaved changes will be lost.", "Are you sure?", "Yes", "No")
//  *   .then((result) => {
//  *     if (result.isConfirmed) {
//  *       // User confirmed
//  *     }
//  *   });
//  */
// export const showConfirm = (
//   text: string,
//   title: string = "Are you sure?",
//   confirmButtonText: string = "Yes",
//   cancelButtonText: string = "No"
// ): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "warning",
//     title,
//     text,
//     showCancelButton: true,
//     confirmButtonText,
//     cancelButtonText,
//   });
// };

// /**
//  * Show validation errors (multiple errors as list)
//  * @param errors - Array of error messages
//  * @param title - Error title (default: "Validation Error", auto-changes to "Validation Errors" if multiple)
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showValidationErrors(["Name is required", "Email is invalid"]);
//  */
// export const showValidationErrors = (
//   errors: string[],
//   title: string = "Validation Error"
// ): Promise<any> => {
//   const isMultiple = errors.length > 1;
//   const errorList = errors.map((err) => `• ${err}`).join("<br>");

//   return Swal.fire({
//     ...getBaseConfig(),
//     icon: "error",
//     title: isMultiple ? "Validation Errors" : title,
//     html: `<div style="text-align: left;">${errorList}</div>`,
//     confirmButtonText: "OK",
//     allowOutsideClick: false,
//     allowEscapeKey: true,
//   });
// };

// /**
//  * Show custom alert with full control
//  * @param options - SweetAlert2 options object (will be merged with base theme config)
//  * @returns Promise that resolves when the alert is closed
//  * 
//  * @example
//  * showCustom({
//  *   icon: "question",
//  *   title: "Custom Alert",
//  *   text: "This is a custom alert",
//  *   showCancelButton: true
//  * });
//  */
// export const showCustom = (options: any): Promise<any> => {
//   return Swal.fire({
//     ...getBaseConfig(),
//     ...options,
//   });
// };















import Swal from "sweetalert2";

// Theme colors matching the website
const THEME_COLORS = {
  primary: "#3969E7",
  primaryDark: "#2a52cf",
  danger: "#dc3545",
  warning: "#ffc107",
  success: "#28a745",
  info: "#17a2b8",
  text: "#212529",
  border: "#ced4da",
  background: "#ffffff",
};

// Common Swal configuration matching the theme
const getBaseConfig = () => ({
  customClass: {
    popup: "swal-popup-theme",
    title: "swal-title-theme",
    htmlContainer: "swal-html-container-theme",
    confirmButton: "swal-confirm-button-theme",
    cancelButton: "swal-cancel-button-theme",
    actions: "swal-actions-theme",
  },
  buttonsStyling: false,
  allowOutsideClick: false,
  allowEscapeKey: true,
});

// Inject theme styles
const injectThemeStyles = () => {
  if (document.getElementById("swal-theme-styles")) return;

  const style = document.createElement("style");
  style.id = "swal-theme-styles";
  style.textContent = `
    .swal-popup-theme {
      font-family: 'Poppins', sans-serif !important;
      font-size: 13px !important;
      border-radius: 8px !important;
      padding: 0 !important;
      padding-bottom: 30px !important;
    }

    .swal-title-theme {
      font-family: 'Poppins', sans-serif !important;
      font-size: 20px !important;
      font-weight: 600 !important;
      color: ${THEME_COLORS.text} !important;
      margin-bottom: 16px !important;
    }

    .swal-html-container-theme {
      font-family: 'Poppins', sans-serif !important;
      font-size: 13px !important;
      color: ${THEME_COLORS.text} !important;
      line-height: 1.5 !important;
    }

    .swal-confirm-button-theme {
      font-family: 'Poppins', sans-serif !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      background-color: ${THEME_COLORS.primary} !important;
      color: #ffffff !important;
      border: none !important;
      border-radius: 4px !important;
      padding: 8px 20px !important;
      margin: 0 4px !important;
      cursor: pointer !important;
      transition: background-color 0.2s ease !important;
    }

    .swal-confirm-button-theme:hover {
      background-color: ${THEME_COLORS.primaryDark} !important;
    }

    .swal-cancel-button-theme {
      font-family: 'Poppins', sans-serif !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      background-color: #ffffff !important;
      color: ${THEME_COLORS.text} !important;
      border: 1px solid ${THEME_COLORS.border} !important;
      border-radius: 4px !important;
      padding: 8px 20px !important;
      margin: 0 4px !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
    }

    /* 🌀 Make sure spinner follows theme */
    .swal2-loader {
      border-color: ${THEME_COLORS.primary} transparent ${THEME_COLORS.primary} transparent !important;
      animation: swal2-rotate-loading 0.8s linear infinite !important;
    }
  `;
  document.head.appendChild(style);
};

// Initialize styles
injectThemeStyles();

/* --------------------- ALERT FUNCTIONS --------------------- */

export const showError = (text: string, title = "Error"): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    icon: "error",
    title,
    text,
    confirmButtonText: "OK",
  });

export const showSuccess = (text: string, title = "Success"): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    icon: "success",
    title,
    text,
    confirmButtonText: "OK",
  });

export const showWarning = (text: string, title = "Warning"): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    icon: "warning",
    title,
    text,
    confirmButtonText: "OK",
  });

export const showInfo = (text: string, title = "Information"): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    icon: "info",
    title,
    text,
    confirmButtonText: "OK",
  });

export const showConfirm = (
  text: string,
  title = "Are you sure?",
  confirmButtonText = "Yes",
  cancelButtonText = "No"
): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });

/* 🧾 MULTIPLE VALIDATION ERRORS */
export const showValidationErrors = (
  errors: string[],
  title = "Validation Error"
): Promise<any> => {
  const isMultiple = errors.length > 1;
  const errorList = errors.map((err) => `• ${err}`).join("<br>");
  return Swal.fire({
    ...getBaseConfig(),
    icon: "error",
    title: isMultiple ? "Validation Errors" : title,
    html: `<div style="text-align: left;">${errorList}</div>`,
    confirmButtonText: "OK",
  });
};

/* 🧠 FULL CUSTOM ALERT */
export const showCustom = (options: any): Promise<any> =>
  Swal.fire({
    ...getBaseConfig(),
    ...options,
  });

/* 🚀 FIXED LOADING (Spinner matches theme) */
export const showLoading = (text = "Processing..."): void => {
  Swal.fire({
    ...getBaseConfig(),
    title: text,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();

      // 🎯 Spinner color is applied AFTER Swal renders
      const loader = document.querySelector(".swal2-loader") as HTMLElement;
      if (loader) {
        loader.style.borderColor = `${THEME_COLORS.primary} transparent ${THEME_COLORS.primary} transparent`;
      }
    },
  });
};

export const hideLoading = (): void => Swal.close();


/* 🧠 FULL CUSTOM ALERT  (Drop-in replacement for Swal.fire) */
export const showCustomSwal = ({
  icon = "info",
  title = "",
  text = "",
  html = "",
  confirmButtonText = "OK",
  cancelButtonText,
  showCancelButton = false,
  ...rest
}: any): Promise<any> => {
  return Swal.fire({
    ...getBaseConfig(),
    icon,
    title,
    text,
    html,
    confirmButtonText,
    showCancelButton,
    cancelButtonText,
    ...rest, // supports ANY Swal.fire option!
  });
};
